export default __webpack_public_path__ + "static/media/futura-medium.3bb7ff9f.woff";